import {ReactElement} from "react";
import {StyledBoxColumn} from "../../shared/StyledComponents";
import {Page} from "../types";
import {Typography} from "@mui/material";
import {StoredDataFileUploadFragment} from "../../shared/StoredDateFileUploadFragment";
import {DIVIDER} from "../../shared/dimens";

export default function ProviderPageVerificationRegistration({page, value, setValue}: {
  page: Page,
  value: string,
  setValue: (url: string) => void
}): ReactElement {
  return <StyledBoxColumn>
    <Typography variant="h6">{page.providerPageProfile.basicInfo.displayName()}</Typography>
    <StoredDataFileUploadFragment
      style={{border: DIVIDER}}
      mimeTypes={["image/*"]}
      storedDataSource={"provider-page-verifications"}
      initialUrls={value ? [value] : undefined}
      onUploadDone={(urls: string[]) => {
        setValue(urls[0]);
      }}/>
    <Typography variant={"body2"}>
      Please upload your medical registration proof. Only licensed doctors can be listed and searched on Dentwyze.
      <br/>
      <br/>
      Acceptable documents:
      <ul>
        <li>Dental Council Certificate</li>
        <li>Government-issued Practice License</li>
      </ul>
    </Typography>
  </StyledBoxColumn>
}

export function renderProviderPageVerificationRegistration(page: Page, value: string, setValue: (url: string) => void): ReactElement {
  return <ProviderPageVerificationRegistration page={page} value={value} setValue={setValue}/>;
}